import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Code } from 'lucide-react';

const Footer = () => {
  return (
    <motion.footer 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="w-full bg-gradient-to-br from-[#101C10] to-[#112811] backdrop-blur-sm border-t border-[#2fe22f]/10"
    >
      <div className="container mx-auto px-6 py-6">
        <motion.div 
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="flex flex-col sm:flex-row justify-center items-center gap-4"
        >
          <div className="flex items-center gap-3">
            <div className="p-2 bg-[#2fe22f]/10 rounded-lg">
              <Code className="w-5 h-5 text-[#2fe22f]" />
            </div>
            <p className="text-gray-300 flex items-center gap-2">
              Designed & Developed with 
              <motion.div
                animate={{ 
                  scale: [1, 1.2, 1],
                }}
                transition={{
                  duration: 1.5,
                  repeat: Infinity,
                  ease: "easeInOut"
                }}
              >
                <Heart className="w-4 h-4 text-[#2fe22f]" />
              </motion.div>
              by
            </p>
          </div>
          
          <a 
            href="https://github.com/Alroy05" 
            target="_blank" 
            rel="noopener noreferrer"
            className="group relative"
          >
            <span className="text-[#2fe22f] font-medium transition-colors">
              Alroy Pereira
            </span>
            <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#2fe22f]/50 group-hover:w-full transition-all duration-300" />
          </a>
        </motion.div>
      </div>
    </motion.footer>
  );
};

export default Footer;